// Global Version Configuration for Helix 2000 MMORPG

export const GAME_VERSION = {
  // Major version (breaking changes)
  major: 0,

  // Minor version (new features)
  minor: 67,

  // Patch version
  patch: 0,

  // Build metadata (auto-generated)
  get build() {
    const now = new Date();
    if (import.meta.env.PROD) {
      return now.toISOString().replace(/[:.]/g, '-').slice(0, 19);
    }
    return `dev-${now.getTime()}`;
  },

  // Environment
  environment: import.meta.env.MODE || 'development',

  // Git commit hash (injected by build script)
  get commitHash() {
    return import.meta.env.VITE_GIT_COMMIT || 'unknown';
  },

  // Full version string with commit info
  get full() {
    const shortHash = this.commitHash.slice(0, 8);
    const patchStr = this.patch > 0 ? `.${this.patch}` : '';
    return `${this.major}.${this.minor}${patchStr}+${shortHash}`;
  },

  // Display version (user-friendly)
  get display() {
    const patchStr = this.patch > 0 ? `.${String(this.patch).padStart(2, '0')}` : '';
    return `v${this.major}.${this.minor}${patchStr}`;
  },

  // Game title with version. Tagline reflects current product state — see
  // OPEN_ITEMS for the proper version-architecture refactor (separate
  // server/client/protocol/content version concerns); this constant is the
  // pure presentation slot.
  get title() {
    return `Helix 2000 Alpha ${this.display} — Multiplayer Alpha`;
  },

  // Detailed version for development
  get detailed() {
    return `${this.display} (${this.build}) [${this.commitHash.slice(0, 8)}]`;
  }
};

// Export version info for easy importing
export const VERSION_INFO = {
  version: GAME_VERSION.display,
  fullVersion: GAME_VERSION.full,
  title: GAME_VERSION.title,
  environment: GAME_VERSION.environment,
  buildTime: GAME_VERSION.build,
  lastUpdated: new Date().toISOString()
};

// Export convenience functions
export const getVersionDisplay = () => GAME_VERSION.display;
export const getVersionFull = () => GAME_VERSION.full;
export const getGameTitle = () => GAME_VERSION.title;
